import { render, staticRenderFns } from "./InvalidCharMsg.vue?vue&type=template&id=2f523154&scoped=true&"
import script from "./InvalidCharMsg.vue?vue&type=script&lang=js&"
export * from "./InvalidCharMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f523154",
  null
  
)

export default component.exports